<!-- 弹窗二次封装 -->
<template>
  <component
    :is="compName"
    :width="compWidth"
    :size="compWidth"
    :position="position"
    :with-header="withHeader"
    :inner="inner"
    :append-to-body="appendToBody"
    :destroy-on-close="destroyOnClose"
    :close-on-click-modal="closeOnClickModal"
    :maxable="maxable"
    class="lzd-modal"
    v-bind="attrs"
  >
    <!-- 透传所有插槽 -->
    <template v-for="name in Object.keys($slots)" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"></slot>
    </template>
  </component>
</template>

<script lang="ts" setup>
  import { useAttrs, computed } from 'vue';
  import { EleDrawer, EleModal } from 'ele-admin-plus';

  import LzdUtil from '@/utils/lzd-util';

  const attrs = useAttrs();

  const props = withDefaults(
    defineProps<{
      lzdModalType?: 'modal' | 'drawer';
      width?: string | number;
      size?: string | number;
      position?:
        | 'top'
        | 'bottom'
        | 'left'
        | 'right'
        | 'leftTop'
        | 'leftBottom'
        | 'rightTop'
        | 'rightBottom'
        | 'center'
        | {
            top?: string | number;
            left?: string | number;
            bottom?: string | number;
            right?: string | number;
          };
      withHeader?: boolean;
      inner?: boolean;
      appendToBody?: boolean;
      destroyOnClose?: boolean;
      closeOnClickModal?: boolean;
      maxable?: boolean;
    }>(),
    {
      position: 'center',
      withHeader: true,
      inner: false,
      appendToBody: true,
      destroyOnClose: true,
      closeOnClickModal: false,
      maxable: true
    }
  );
  // 动态组件名称
  const compName = computed(() => {
    if (props.lzdModalType) {
      return props.lzdModalType !== 'modal' ? EleDrawer : EleModal;
    }
    const isModal = LzdUtil.getGlobalModalType().value !== 'drawer';
    return isModal ? EleModal : EleDrawer;
  });

  const compWidth = computed(() => {
    return props.width ?? props.size;
  });
  defineOptions({ name: 'LzdModal' });
</script>
